export const GENERIC_ERROR_MESSAGE =
  'An error occurred resetting the password. Please try again';
export const TOKEN_ERROR_MESSAGE =
  'The reset request is invalid or expired. Please try resetting your password again';
